import { t } from "@/i18n-js/instance";
import { EntityResource } from "../EntityResource";
import type { EventOption } from "../types";
import { AnyPaywallSpecificSelector } from "./shared/AnyPaywallSpecificSelector";

export const couponRemoved: Readonly<EventOption> = {
  label: t("workflows_v2.events.community_member_coupon_removed.title"),
  value: "community_member_coupon_removed",
  group: t("settings.workflows.form.event_groups.paywalls"),
  description: t(
    "workflows_v2.events.community_member_coupon_removed.description",
  ),
  formComponent: AnyPaywallSpecificSelector,
  viewComponent: EntityResource,
  icon: "paywall",
};
